module.exports = __webpack_public_path__ + "static/media/zxs_jcb.38123b90.png";